import FileDropzone from "app/components/FileDropzone";
import type { CreateAssetResponse } from "app/components/MediaUploader/types";
import React from "react";
import { useDispatch } from "react-redux";
import AddTaskComponent from ".";
import TicketAttachmentUpload from "../../../Ticket/components/TicketAttachmentUpload";
import { ticketGroupsActions } from "../../containers/Tickets/redux/slice";
import { IWorkspaceProjects, IWorkspaceTeams } from "app/types";

interface Props {
  sprintName: string;
  selectedTeam: IWorkspaceTeams;
  selectedProject: IWorkspaceProjects;
  createTicketForHome: boolean;
  isAddEpicModal?: boolean;
}
const AddTaskModalContent: React.FC<Props> = ({
  selectedProject,
  sprintName,
  selectedTeam,
  createTicketForHome,
  isAddEpicModal = false,
}) => {
  const dispatch = useDispatch();

  const externalFileInputRef = React.useRef<HTMLInputElement>(null);

  const handleUploadSuccess = (data: CreateAssetResponse) => {
    dispatch(ticketGroupsActions.setTicketAttachments({ data }));
  };

  const handleLoadingChange = (loading: boolean) => {};

  return (
    <TicketAttachmentUpload
      fileInputRef={externalFileInputRef}
      onUploadSuccess={handleUploadSuccess}
      onLoadingChange={handleLoadingChange}
    >
      {({
        isDragging,
        handleDragOver,
        handleDragLeave,
        handleDrop,
        triggerFileDialog,
        isLoading,
      }) => (
        <div
          className="w-full h-full relative"
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          {isDragging ? (
            <FileDropzone
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              className="min-h-[50vh]"
            />
          ) : (
            <AddTaskComponent
              sprintName={sprintName}
              selectedTeam={selectedTeam}
              selectedProject={selectedProject}
              createTicketForHome={createTicketForHome}
              isAddEpicModal={isAddEpicModal}
            />
          )}
        </div>
      )}
    </TicketAttachmentUpload>
  );
};

export default AddTaskModalContent;
